<template>
  <div class="progress-with-count">
    <div class="progress-header">{{currentValue}} of {{maxValue}}</div>
    <div class="progress">
      <div class="progress-bar" role="progressbar" :style="progressBarStyle" :aria-valuenow="percentage" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Progress',
  props: ['currentValue', 'maxValue'],
  data () {
    return {
    }
  },
  computed: {
    percentage () {
      return Math.floor(this.currentValue * 100 / this.maxValue)
    },
    progressBarStyle () {
      return {
        width: `${this.percentage === 0 ? 1 : this.percentage}%`
      }
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.progress-header {
  text-align: center;
}
</style>
